import i18n from '@/plugins/i18n';
import {
  ADD_GROK_PATTERN,
  ADD_SAVED_SEARCH,
  BAR_GRAPH,
  STATUS_LABEL,
  LINE_GRAPH,
  TABLE_WIDGET,
  EDIT_MENU_KEY,
  DELETE_MENU_KEY,
  RUN_MENU_KEY,
  ADD_WIDGET_MENU_KEY,
  ALERT_MENU_KEY,
  COPY_MENU_KEY,
} from '@/components/Log/log.constants';

const grokAddActions = () => [
  { name: i18n.global.t('log.grokPattern'), value: ADD_GROK_PATTERN },
];

const savedSearchAddActions = () => [
  { name: i18n.global.t('log.savedSearch'), value: ADD_SAVED_SEARCH },
];

const lastUpdateTimeStamp = 'last_update_timestamp';

const grokTableHeaders = () => [
  { name: i18n.global.t('log.name'), key: 'rule_name', width: '15%' },
  { name: i18n.global.t('log.service'), key: 'service_name', width: '17.5%' },
  { name: i18n.global.t('log.logName'), key: 'tag_name', width: '17.5%' },
  {
    name: i18n.global.t('createdOn'),
    key: lastUpdateTimeStamp,
    width: '12%',
    sortable: true,
  },
  { name: i18n.global.t('log.grokPattern'), key: 'pattern', width: '34%' },
  { name: '', key: 'actions', width: '4%' },
];

const savedSearchHeaders = () => [
  { name: i18n.global.t('log.name'), key: 'savedQueryName', width: '17%' },
  { name: i18n.global.t('log.type'), key: 'savedQueryType', width: '9%' },
  { name: i18n.global.t('log.query'), key: 'query', width: '70%' },
  { name: '', key: 'actions', width: '4%' },
];

const grokSystemGeneratedLabel = 'system-generated';
const grokTimeFormat = 'DD/MM/YYYY HH:mm';
const sortOrder = Object.freeze({
  DESC: 'DESC',
  ASC: 'ASC',
});

const addwidgetMetricTypeOptions = () => [
  {
    iconName: 'lineGraph',
    label: i18n.global.t('log.lineGraph'),
    key: LINE_GRAPH,
    dispGif: false,
  },
  {
    iconName: 'barGraph',
    label: i18n.global.t('log.barGraph'),
    key: BAR_GRAPH,
    dispGif: false,
  },
  {
    iconName: 'statusLabel',
    label: i18n.global.t('log.label'),
    key: STATUS_LABEL,
    dispGif: false,
  },
];

const addWidgetTableTypeOptions = () => [
  {
    iconName: 'tableWidget',
    label: i18n.global.t('log.table'),
    key: TABLE_WIDGET,
    dispGif: false,
  },
];

const addWidgetLabels = {
  [LINE_GRAPH]: 'line graph',
  [BAR_GRAPH]: 'bar graph',
  [STATUS_LABEL]: 'label',
  [TABLE_WIDGET]: 'table',
};

const addWidgetStepperLabels = () => [
  i18n.global.t('log.savedSearch'),
  i18n.global.t('log.addToDashboard'),
];

const dashboardSearchSelectDefulatOption = {
  name: i18n.global.t('log.select'),
  id: '',
};

const addWidgetDefulatData = {
  savedSearchInfo: {
    savedSearchName: '',
    query: '',
  },
  addDashboardInfo: {
    widgetName: '',
    dashboardName: '',
    dashboard: dashboardSearchSelectDefulatOption,
    widgetType: '',
  },
  widgetFormData: {
    isNewDash: false,
    isLoading: false,
    isQueryValid: true,
    isSavedSearchValid: true,
    isWidgetNameValid: true,
    isDashNameValid: true,
    isDashboardValid: true,
    isCreateOrUpdateSavedSearch: true,
    isQueryExecuted: false,
  },
};

const executeSavedSearchDefaultData = {
  isAddWidgetWithoutSavedSearch: false,
  savedSearchName: '',
  service_id: '',
  isTextSearchTypeSelected: false,
  queryMetric: '',
};

const savedSearchTableMenuItems = () => [
  {
    label: i18n.global.t('log.edit'),
    key: EDIT_MENU_KEY,
    isLMANLRole: true,
    icon: 'editFilled',
  },
  {
    label: i18n.global.t('log.delete'),
    key: DELETE_MENU_KEY,
    isLMANLRole: true,
    icon: 'deleteFilled',
  },
  {
    label: i18n.global.t('log.runQuery'),
    key: RUN_MENU_KEY,
    icon: 'runQueryNew',
  },
  {
    label: i18n.global.t('log.addWidget'),
    key: ADD_WIDGET_MENU_KEY,
    isHomeRole: true,
    icon: 'addCusWidget',
  },
  {
    label: i18n.global.t('log.addAlert'),
    key: ALERT_MENU_KEY,
    isAlertView: true,
    icon: 'alert',
  },
];

const grokTableMenuItems = () => [
  { label: i18n.global.t('log.edit'), key: EDIT_MENU_KEY, isAdminRole: true },
  {
    label: i18n.global.t('log.delete'),
    key: DELETE_MENU_KEY,
    isAdminRole: true,
  },
  { label: i18n.global.t('copy'), key: COPY_MENU_KEY },
];
const lmNavbarTabs = () => [
  i18n.global.t('log.services'),
  i18n.global.t('log.logNames'),
  i18n.global.t('log.fields'),
];

const anlyNavbarTabs = () => [
  i18n.global.t('log.services'),
  i18n.global.t('analytics.scriptNames'),
  i18n.global.t('log.fields'),
];

const getRouteName = (isADType) => {
  return isADType ? 'analytics' : 'log';
};
const serviceName = 'service_name';

export {
  grokAddActions,
  savedSearchAddActions,
  grokTableHeaders,
  savedSearchHeaders,
  grokSystemGeneratedLabel,
  grokTimeFormat,
  sortOrder,
  lastUpdateTimeStamp,
  addwidgetMetricTypeOptions,
  addWidgetTableTypeOptions,
  addWidgetLabels,
  addWidgetStepperLabels,
  addWidgetDefulatData,
  dashboardSearchSelectDefulatOption,
  executeSavedSearchDefaultData,
  savedSearchTableMenuItems,
  grokTableMenuItems,
  lmNavbarTabs,
  anlyNavbarTabs,
  getRouteName,
  serviceName,
};
